const CryptoJS = require('crypto-js');

const KEY = CryptoJS.enc.Utf8.parse('aA62uiy024788grd');
const IV = CryptoJS.enc.Utf8.parse('aA62uiy024788grd');
/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function encrypt(word: string, keyStr?: string, ivStr?: string) {
  let key = KEY;
  let iv = IV;

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  const srcs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 */
export function decrypt(word: string, keyStr: string, ivStr: string) {
  let key = KEY;
  let iv = IV;

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  const base64 = CryptoJS.enc.Base64.parse(word);
  const src = CryptoJS.enc.Base64.stringify(base64);

  const content = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
  });

  const decryptedStr = content.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString().replace(/[\r\n]/g, '');
}
